export default __webpack_public_path__ + "static/media/Advanced Card Security Left.4fcc61a5.png";